import { createStore } from "redux";
import reducer from "redux/reducer";

/* eslint-disable no-underscore-dangle */
const Store = createStore(
  reducer /* preloadedState, */,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);
/* eslint-enable */
export default Store;
